






























import Vue from "vue";
import Component from "vue-class-component";
@Component({
    name: "CabinetHeader",
})

export default class CabinetHeader extends Vue {
    get hasAccessModule(): boolean {
        const moduleCode = "100.000.004";
        const accessLevel = this.$store.state.user.userModules.find(
            (it: any) => it.modules === moduleCode
        );
        return !!accessLevel;
    }
}
